import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const login = data =>
  request(`${apiUrl}/login`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });

export const verifyAuth = token => request(`${apiUrl}/auth`, token);

export const getAdminSeller = (sellerId, token) =>
  request(`${apiUrl}/admin/sellers/${sellerId}`, token);
